import { SystemVersionDto } from '../types/backendType';
import httpClient from './httpClient';

// GET /system/version
export async function fetchSystemVersion(): Promise<SystemVersionDto> {
  try {
    const response = await httpClient.get<SystemVersionDto>(
      '/system/version?include_components=true',
    );
    const systemVersionDto = response.data;
    return systemVersionDto;
  } catch (e) {
    throw new Error(`Failed to fetch system version: ${e}`);
  }
}
